// extracted by mini-css-extract-plugin
module.exports = {"manualFitnessEntryModal":"jgp-CX_s3","notesTextArea":"jgp-2pUJM"};